import { useEffect } from 'react';
import scriptjs from 'scriptjs';
import PropTypes from 'prop-types';

const LoginBrowserCompat = (props) => {
    const { loginConfig, uiConfig } = props;
    useEffect(() => {
        if (loginConfig) {
            const { links } = loginConfig;
            const browserCompatLink = (links ?? []).find((link) => {
                return (
                    link &&
                    link.propertyName === 'browserCompatibilityLinkLabel'
                );
            });

            if (browserCompatLink) {
                const { olbUIBaseUrl } = uiConfig ?? {};

                const callback = () => {
                    let browserCompatCount = 0;
                    const id = setInterval(() => {
                        if (
                            document.getElementById('test-browser') &&
                            window.onload
                        ) {
                            clearInterval(id);

                            try {
                                window.onload();
                            } catch (e) {} // eslint-disable-line no-empty
                        }
                        browserCompatCount += 1;

                        if (browserCompatCount > 50) {
                            clearInterval(id);
                        }
                    }, 100);

                    return () => {
                        if (id) {
                            clearInterval(id);
                        }
                    };
                };

                // olb may send wrong caps key, in that case load browser-compatscript again
                const { ifs } = window;
                let needsBrowCompatScript = false;

                if (
                    ifs &&
                    ifs.env &&
                    ifs.env.i18nStrings &&
                    ifs.env.i18nStrings.browCompat
                ) {
                    const {
                        browser_compatibility: browCompatEnabled,
                    } = ifs.env.i18nStrings.browCompat;

                    if (!browCompatEnabled || browCompatEnabled === 'false') {
                        ifs.env.i18nStrings.browCompat.browser_compatibility =
                            'true';
                        needsBrowCompatScript = true;
                    }
                }

                if (needsBrowCompatScript) {
                    const browserCompatScript = `${olbUIBaseUrl}browser-test/browser-test-all.js?v=${Date.now()}`;

                    if (browserCompatScript) {
                        scriptjs(browserCompatScript, callback);
                    }
                } else {
                    callback();
                }
            }
        }

        return undefined;
    }, [loginConfig]);

    return false;
};

LoginBrowserCompat.propTypes = {
    loginConfig: PropTypes.instanceOf(Object),
    uiConfig: PropTypes.instanceOf(Object),
};

export default LoginBrowserCompat;
